<div class="row height-100 mr-3">
  <div class="col-12 height-100">
    <app-help-grid></app-help-grid>
  </div>
</div>
